var render = function render(){
  var _vm$currentPlan, _vm$contract, _vm$contract$external, _vm$contract$external2, _vm$contract2, _vm$contract2$externa, _vm$contract2$externa2, _vm$contract3, _vm$contract4, _vm$contract4$externa, _vm$contract4$externa2, _vm$contract5, _vm$contract5$externa, _vm$contract5$externa2, _vm$contract6, _vm$currentPlan2, _vm$contract7, _vm$contract7$externa, _vm$contract7$externa2, _vm$contract8, _vm$contract8$externa, _vm$contract8$externa2, _vm$contract9, _vm$contract9$externa, _vm$contract9$externa2, _vm$contract0, _vm$contract0$externa, _vm$contract0$externa2, _vm$contract1, _vm$contract1$externa, _vm$contract1$externa2, _vm$currentPlan3, _vm$currentPlan3$defi, _vm$contract10, _vm$contract11, _vm$contract12, _vm$subscriptionAddre, _vm$hasPausedContract, _vm$contract13;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "account-info-ctn"
  }, [_c('h2', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('profile.my_subscription')))]), _c('v-container', {
    staticClass: "mt-6 ma-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('current_plan')))]), _c('div', {
    staticClass: "font-weight-light d-flex align-center"
  }, [_vm._v(" " + _vm._s(_vm.getPlanName(_vm.currentPlan)) + " "), !_vm.isFreePlan ? _c('span', {
    staticClass: "extra-tag ml-2",
    class: {
      'trial': ((_vm$currentPlan = _vm.currentPlan) === null || _vm$currentPlan === void 0 ? void 0 : _vm$currentPlan.id) === 'elabel-trial',
      'canceled': ((_vm$contract = _vm.contract) === null || _vm$contract === void 0 ? void 0 : (_vm$contract$external = _vm$contract.external_subscription_data) === null || _vm$contract$external === void 0 ? void 0 : (_vm$contract$external2 = _vm$contract$external.scheduled_change) === null || _vm$contract$external2 === void 0 ? void 0 : _vm$contract$external2.action) === 'cancel' || ((_vm$contract2 = _vm.contract) === null || _vm$contract2 === void 0 ? void 0 : (_vm$contract2$externa = _vm$contract2.external_subscription_data) === null || _vm$contract2$externa === void 0 ? void 0 : (_vm$contract2$externa2 = _vm$contract2$externa.scheduled_change) === null || _vm$contract2$externa2 === void 0 ? void 0 : _vm$contract2$externa2.action) === 'pause' || ((_vm$contract3 = _vm.contract) === null || _vm$contract3 === void 0 ? void 0 : _vm$contract3.cancellation_date)
    }
  }, [((_vm$contract4 = _vm.contract) === null || _vm$contract4 === void 0 ? void 0 : (_vm$contract4$externa = _vm$contract4.external_subscription_data) === null || _vm$contract4$externa === void 0 ? void 0 : (_vm$contract4$externa2 = _vm$contract4$externa.scheduled_change) === null || _vm$contract4$externa2 === void 0 ? void 0 : _vm$contract4$externa2.action) === 'cancel' || ((_vm$contract5 = _vm.contract) === null || _vm$contract5 === void 0 ? void 0 : (_vm$contract5$externa = _vm$contract5.external_subscription_data) === null || _vm$contract5$externa === void 0 ? void 0 : (_vm$contract5$externa2 = _vm$contract5$externa.scheduled_change) === null || _vm$contract5$externa2 === void 0 ? void 0 : _vm$contract5$externa2.action) === 'pause' || (_vm$contract6 = _vm.contract) !== null && _vm$contract6 !== void 0 && _vm$contract6.cancellation_date ? _c('span', [_vm._v(_vm._s(_vm.$t('canceled')))]) : ((_vm$currentPlan2 = _vm.currentPlan) === null || _vm$currentPlan2 === void 0 ? void 0 : _vm$currentPlan2.id) === 'elabel-trial' ? _c('span', [_vm._v(_vm._s(_vm.$t('trial')))]) : _vm._e()]) : _vm._e()])]), (_vm$contract7 = _vm.contract) !== null && _vm$contract7 !== void 0 && (_vm$contract7$externa = _vm$contract7.external_subscription_data) !== null && _vm$contract7$externa !== void 0 && (_vm$contract7$externa2 = _vm$contract7$externa.scheduled_change) !== null && _vm$contract7$externa2 !== void 0 && _vm$contract7$externa2.action ? _c('v-col', [((_vm$contract8 = _vm.contract) === null || _vm$contract8 === void 0 ? void 0 : (_vm$contract8$externa = _vm$contract8.external_subscription_data) === null || _vm$contract8$externa === void 0 ? void 0 : (_vm$contract8$externa2 = _vm$contract8$externa.scheduled_change) === null || _vm$contract8$externa2 === void 0 ? void 0 : _vm$contract8$externa2.action) === 'cancel' || ((_vm$contract9 = _vm.contract) === null || _vm$contract9 === void 0 ? void 0 : (_vm$contract9$externa = _vm$contract9.external_subscription_data) === null || _vm$contract9$externa === void 0 ? void 0 : (_vm$contract9$externa2 = _vm$contract9$externa.scheduled_change) === null || _vm$contract9$externa2 === void 0 ? void 0 : _vm$contract9$externa2.action) === 'pause' ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ends_on')))]) : _vm._e(), ((_vm$contract0 = _vm.contract) === null || _vm$contract0 === void 0 ? void 0 : (_vm$contract0$externa = _vm$contract0.external_subscription_data) === null || _vm$contract0$externa === void 0 ? void 0 : (_vm$contract0$externa2 = _vm$contract0$externa.scheduled_change) === null || _vm$contract0$externa2 === void 0 ? void 0 : _vm$contract0$externa2.action) === 'resume' ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('resumes_on')))]) : _vm._e(), _c('div', {
    staticClass: "font-weight-light"
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$contract1 = _vm.contract) === null || _vm$contract1 === void 0 ? void 0 : (_vm$contract1$externa = _vm$contract1.external_subscription_data) === null || _vm$contract1$externa === void 0 ? void 0 : (_vm$contract1$externa2 = _vm$contract1$externa.scheduled_change) === null || _vm$contract1$externa2 === void 0 ? void 0 : _vm$contract1$externa2.effective_at)) + " ")])]) : _vm._e(), !_vm.isFreePlan ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('total_qr_codes')))]), _c('div', {
    staticClass: "font-weight-light capitalize"
  }, [_vm._v(_vm._s((_vm$currentPlan3 = _vm.currentPlan) !== null && _vm$currentPlan3 !== void 0 && (_vm$currentPlan3$defi = _vm$currentPlan3.definition) !== null && _vm$currentPlan3$defi !== void 0 && _vm$currentPlan3$defi['quota:code'] ? _vm.formatNumber(_vm.currentPlan.definition['quota:code']) : _vm.$t('unlimited')))])]) : _vm._e(), (_vm$contract10 = _vm.contract) !== null && _vm$contract10 !== void 0 && _vm$contract10.valid_to ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [!_vm.isTrialPlan ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('next_payment')))]) : _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('trial_ends_on')))]), _c('div', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.formatDate((_vm$contract11 = _vm.contract) === null || _vm$contract11 === void 0 ? void 0 : _vm$contract11.valid_to)))])]) : _vm._e(), (_vm$contract12 = _vm.contract) !== null && _vm$contract12 !== void 0 && _vm$contract12.valid_to && !_vm.hasPendingChanges && !_vm.hasPausedContract && !_vm.isTrialPlan ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "disable": _vm.loading,
      "outlined": "",
      "color": "red"
    },
    on: {
      "click": function ($event) {
        _vm.cancelSubscriptionDialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel_subscription')))])], 1) : _vm._e(), _vm.hasPendingChanges ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading,
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        _vm.resumeSubscriptionDialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('resume_subscription')))])], 1) : _vm.hasPausedContract ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading,
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        _vm.resumeSubscriptionDialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('resume_subscription')))])], 1) : _vm.isFreePlan ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.goToUpgrade();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('subscribe')))])], 1) : _vm._e()], 1)], 1), !_vm.isFreePlan && !_vm.isTrialPlan ? _c('h2', {
    staticClass: "header-text mt-6"
  }, [_vm._v(_vm._s(_vm.$t('profile.billing_information')))]) : _vm._e(), !_vm.isFreePlan && !_vm.isTrialPlan ? _c('v-container', {
    staticClass: "mt-6 ma-0"
  }, [_c('billing-customer', {
    ref: "billing-customer-form",
    attrs: {
      "customer": _vm.customer
    }
  }), _c('billing-business', {
    ref: "billing-business-form",
    attrs: {
      "country": ((_vm$subscriptionAddre = _vm.subscriptionAddress) === null || _vm$subscriptionAddre === void 0 ? void 0 : _vm$subscriptionAddre.country_code) || '',
      "business": _vm.subscriptionBusiness || {}
    }
  }), _c('billing-address', {
    ref: "billing-address-form",
    attrs: {
      "address": _vm.subscriptionAddress || {}
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "disabled": _vm.loading,
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.updateBillingInformation();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.update')))])], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "paddle-portal-btn font-weight-light",
    on: {
      "click": function ($event) {
        return _vm.goToPaddleBillingPortal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.paddle_billing_details')))])])], 1)], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "width": "550"
    },
    model: {
      value: _vm.resumeSubscriptionDialog,
      callback: function ($$v) {
        _vm.resumeSubscriptionDialog = $$v;
      },
      expression: "resumeSubscriptionDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('resume_subscription')))]), _c('v-card-text', {
    staticClass: "py-5 px-5 black--text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('resume_subscription_modal_description', {
        planName: _vm.getPlanName(_vm.hasPendingChanges ? _vm.currentPlan : (_vm$hasPausedContract = _vm.hasPausedContract) === null || _vm$hasPausedContract === void 0 ? void 0 : _vm$hasPausedContract.plan)
      }))
    }
  })]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.resumeSubscriptionDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "primary": "",
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.hasPendingChanges ? _vm.undoPendingChanges() : _vm.resumeSubscription();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('confirm')))])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "550"
    },
    model: {
      value: _vm.cancelSubscriptionDialog,
      callback: function ($$v) {
        _vm.cancelSubscriptionDialog = $$v;
      },
      expression: "cancelSubscriptionDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('cancel_subscription')))]), _c('v-card-text', {
    staticClass: "py-5 px-5 black--text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('cancel_subscription_modal_description', {
        planName: _vm.getPlanName(_vm.currentPlan),
        billingDate: _vm.formatDate((_vm$contract13 = _vm.contract) === null || _vm$contract13 === void 0 ? void 0 : _vm$contract13.valid_to)
      }))
    }
  }), _c('div', [_c('v-checkbox', {
    staticClass: "black--text",
    attrs: {
      "label": _vm.$t('keep_payment_information'),
      "hint": _vm.$t('keep_payment_information_hint'),
      "persistent-hint": ""
    },
    model: {
      value: _vm.keepPaymentInfo,
      callback: function ($$v) {
        _vm.keepPaymentInfo = $$v;
      },
      expression: "keepPaymentInfo"
    }
  })], 1)]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.cancelSubscriptionDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "disabled": _vm.cancelling,
      "color": "error"
    },
    on: {
      "click": function ($event) {
        return _vm.cancelSubscription();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel_subscription')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }